import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '@cd/sdds-common-components-react';

const getMPLogs = (requestPayload: MPLogRequestPayloadType): AxiosPromise<MPLogResponseType> => csttFacadeApi.post(`/csttfacade/telematicsunit/v1/rtclogs`, requestPayload);

export {
    getMPLogs
 };

